"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationClient = void 0;
const base_client_1 = require("@deliverr/base-client");
const client_auth_1 = require("@deliverr/client-auth");
const core_auth_1 = require("@deliverr/core-auth");
class NotificationClient extends base_client_1.ApiBasicAuthClient {
    constructor(config = { authEngine: core_auth_1.AuthEngine.COGNITO_INTERNAL }) {
        const clientConfig = Object.assign(Object.assign({}, config), { baseURL: `${config.baseURL || process.env.NOTIFICATION_CLIENT_URL}`, authEngine: config.authEngine });
        super(clientConfig);
        if (config.authEngine === core_auth_1.AuthEngine.COGNITO_INTERNAL) {
            const tokenRefreshFn = new client_auth_1.OAuthClientTokenBuilder(clientConfig).getTokenFn();
            this.axios.interceptors.request.use(async (requestConfig) => {
                this.withAccessToken(await tokenRefreshFn());
                return requestConfig;
            });
        }
    }
    async createNotification(notification) {
        return this.post("/v2/notifications", notification);
    }
    async getNotification(notificationId) {
        return this.get(`/v2/notifications/${encodeURIComponent(notificationId)}`);
    }
    async getNotificationGroups(sellerId, groupBy, excludeBy, excludes, tz, field, numDaysInPast) {
        return this.get(`/v2/notifications/sellers/${encodeURIComponent(sellerId)}/groups`, {
            groupBy,
            excludeBy,
            excludes,
            tz,
            field,
            numDaysInPast,
        });
    }
    async getNotifications(sellerId, limit, offset, excludeBy, excludes) {
        return this.get(`/v2/notifications/sellers/${encodeURIComponent(sellerId)}`, {
            limit,
            offset,
            excludeBy,
            excludes,
        });
    }
    async viewNotification(notificationId) {
        return this.put(`/v2/notifications/${encodeURIComponent(notificationId)}/view`, {});
    }
    async acknowledgeNotification(notificationId) {
        return this.put(`/v2/notifications/${encodeURIComponent(notificationId)}/acknowledge`, {});
    }
    async acknowledgeNotifications(filter) {
        return this.put("/v2/notifications/acknowledge", filter);
    }
}
exports.NotificationClient = NotificationClient;
//# sourceMappingURL=NotificationClient.js.map